import type { ViewStateSelectors } from 'owa-timestream-asset-sdk';
import {
    clearSelectedAssets,
    selectAsset,
    startDraggingAssets,
    toggleAssetSelection,
} from './actions';
import isCanvasLocked from './selectors/isCanvasLocked';
import getSelectedAssetTypes from './selectors/getSelectedAssetTypes';
import getZoom from './selectors/getZoom';
import isMovingAssets from './selectors/isMovingAssets';
import isSelectedAsset from './selectors/isSelectedAsset';

const viewStateSelectors: ViewStateSelectors = {
    isSelectedAsset,
    selectAsset,
    getSelectedAssetTypes,
    clearSelectedAssets,
    startDraggingAssets,
    isMovingAssets,
    toggleAssetSelection,
    getZoom,
    isCanvasLocked,
};

export default viewStateSelectors;
